import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import EditableAutocomplete from "../../../components/EditableAutocomplete.js";
import EditableField from "../../../components/EditableField.js";
import EditButton from "../../../components/EditButton.js";

export default function PlotInvolvements({
  buttonAriaLabel,
  involvements,
  handleChange,
  handleDelete,
  isEditing,
  predictiveList = [],
  characterNameLabel,
  involvementLabel,
}) {
  return (
    <List>
      {involvements.map((item, index) => {
        const {
          character: { host: { user: { imageUrl } = {} } = {}, id, name } = {},
          involvement,
        } = item;
        const collapsedName = name?.replaceAll(" ", "");
        const characterNameId = `plot-character-${collapsedName}`;

        return (
          <Box key={index} display="flex" alignItems="start">
            <ListItem alignItems="flex-start" disableGutters>
              <ListItemAvatar>
                <Avatar alt={name} src={imageUrl} variant="rounded" />
              </ListItemAvatar>
              <ListItemText
                disableTypography
                primary={
                  <EditableAutocomplete
                    disabledOptions={(option) =>
                      involvements.some(
                        ({ character }) => character?.id === option.id
                      )
                    }
                    id={characterNameId}
                    isEditing={!item.id}
                    label={characterNameLabel}
                    onChange={(event, value) =>
                      handleChange({
                        field: "character",
                        index,
                        value: value || {},
                      })
                    }
                    route={`/plots/characters/${id}`}
                    state={{ id }}
                    optionLabel={(option) => option.name || ""}
                    options={predictiveList}
                    text={name}
                    value={
                      predictiveList?.find((option) => option.id === id) || {}
                    }
                  />
                }
                secondary={
                  <EditableField
                    id={`plot-character-involvement-${collapsedName}`}
                    isEditing={isEditing}
                    label={involvementLabel}
                    multiline
                    onChange={({ target }) =>
                      handleChange({
                        field: "involvement",
                        index,
                        value: target.value,
                      })
                    }
                    text={involvement}
                    value={involvement ?? ""}
                    variant="body2"
                  />
                }
                sx={{ display: "flex", flexDirection: "column" }}
              />
            </ListItem>
            {isEditing && (
              <EditButton
                ariaLabel={buttonAriaLabel}
                isEditing={isEditing}
                onClick={() => handleDelete(index)}
                primaryIcon={<DeleteOutlineIcon />}
              />
            )}
          </Box>
        );
      })}
    </List>
  );
}
